import React from 'react'
import PropTypes from 'prop-types'
import FooterLink from './FooterLink'
import DynamicLinks from './DynamicLinks'
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";
import {useI18nContext} from "../i18n/I18nContext";

export default function Footer({legalInfo}) {
    const context = useI18nContext()
    const footerText = `© ${(new Date()).getFullYear()} Deutsche Post AG`;

    return <footer id="footer" className="dpag-footer footer mt-5 mb-5"
                   aria-label={getI18nTextWithContext(context, 'a11y.aria.footer')}>
            <div className="container border-top">
                <p className="mt-3 mb-0">
                    {footerText}
                </p>
                <nav className="navbar navbar-expand pt-1 pl-0 pr-0"
                     aria-label={getI18nTextWithContext(context, 'a11y.aria.footer.list')}>
                    <ul className="navbar-nav flex-column flex-md-row">
                        <FooterLink target={getI18nTextWithContext(context, 'imprint_url')}
                                    text={getI18nTextWithContext(context, 'footer.imprint')}
                                    dataTestId="60a6ce18-745e"/>
                        <DynamicLinks legalInfo={legalInfo}/>
                        <FooterLink target={getI18nTextWithContext(context, 'legalnotes_url')}
                                    text={getI18nTextWithContext(context, 'footer.legalNotes')}
                                    dataTestId="26674d13-88b6"/>
                        <FooterLink target={getI18nTextWithContext(context, 'accessibility_url')}
                                    text={getI18nTextWithContext(context, 'footer.accessibility')}
                                    dataTestId="86532c19-78k5"/>
                    </ul>
                </nav>
            </div>
        </footer>
}

Footer.propTypes = {
    legalInfo: PropTypes.object,
}